import { lazy } from 'react';

// Types
import { POSCreditProps as LazyComponentProps } from './POSCredit.types';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() => lazyRetry(() => import(/* webpackChunkName: "posCredit" */ './POSCredit')));

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'POSCredit');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as POSCredit };
